<template>
  <main>
    <HeaderNav :lmid="1" />

    <section class="Home_Banner">
      <div class="banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in banner_data"
              :key="index"
            >
              <picture>
                <source media="(max-width:1200px)" :srcset="item.mbanner" />
                <source media="(min-width:1200px)" :srcset="item.banner" />
                <img src="" alt="" />
              </picture>
              <div class="posi" v-if="item.title != '1'">
                <div class="w1520">
                  <div class="main">
                    <div class="content1" v-html="item.eng_title"></div>
                    <div class="content2" v-html="item.title"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-pagination"></div> -->
          <!-- <div class="swiper-button-prev"></div> -->
          <!-- <div class="swiper-button-next"></div> -->
        </div>
        <div class="orientation">
          <div class="w1520">
            <div class="main flexBetween">
              <div class="page">
                <div></div>
              </div>
              <div class="btn flexBetween">
                <div class="l">Scroll</div>
                <div class="r">
                  <img src="@/assets/images/icon1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg"><img src="@/assets/images/img9.png" alt="" /></div>
    </section>

    <section class="Home_Product">
      <div class="w1520 p95 p95_">
        <div class="homeTitle">
          <div
            class="f60 wow animate__animated animate__fadeInUp"
            v-html="product_title.typename"
          ></div>
        </div>
        <div class="box wow animate__animated animate__fadeInUp" >
          <div class="swiper-container">
            <div class="swiper-wrapper" ref="swiperitem">
              <div
                class="swiper-slide"
                v-for="(item, index) in product_data"
                :key="index"
              >
                <div class="item">
                  <router-link :to="{ path: '/productInfo?id=' + item.link }">
                    <figure class="radius">
                      <img :src="item.img" alt="" />
                    </figure>
                    <figcaption>
                      <div class="tit ellipsis">{{ item.title }}</div>
                      <div class="desc ellipsis3" v-html="item.desc"></div>
                      <div class="btn">
                        <div class="one flexCenter">
                          <div class="home_button1">
                            <div class="a flexCenter">
                              <div class="l">查看详情</div>
                              <div class="r">
                                <div class="home_button2">
                                  <svg
                                    width="19"
                                    height="16"
                                    viewBox="0 0 19 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6997 15.4099L18.1798 8.92993C18.3009 8.81031 18.397 8.66781 18.4626 8.51074C18.5283 8.35367 18.5621 8.18512 18.5621 8.01489C18.5621 7.84466 18.5283 7.67611 18.4626 7.51904C18.397 7.36197 18.3009 7.21947 18.1798 7.09985L11.6997 0.619873C11.5795 0.499714 11.4369 0.404385 11.2799 0.339355C11.1229 0.274326 10.9547 0.240967 10.7848 0.240967C10.6149 0.240967 10.4465 0.274326 10.2896 0.339355C10.1326 0.404385 9.98991 0.499714 9.86975 0.619873C9.74959 0.740033 9.65426 0.882799 9.58923 1.03979C9.5242 1.19679 9.49072 1.36498 9.49072 1.53491C9.49072 1.70484 9.5242 1.87303 9.58923 2.03003C9.65426 2.18703 9.74959 2.32979 9.86975 2.44995L14.1298 6.71997H1.70972C1.53009 6.70417 1.34924 6.72579 1.17847 6.78369C1.0077 6.84159 0.850748 6.93436 0.717773 7.05615C0.584799 7.17794 0.478649 7.32617 0.406006 7.49121C0.333363 7.65625 0.295898 7.83457 0.295898 8.01489C0.295898 8.19521 0.333363 8.37353 0.406006 8.53857C0.478649 8.70362 0.584799 8.85184 0.717773 8.97363C0.850748 9.09542 1.0077 9.18819 1.17847 9.24609C1.34924 9.304 1.53009 9.32561 1.70972 9.30981H14.1298L9.86975 13.5798C9.74772 13.6997 9.65111 13.8431 9.58582 14.0012C9.52052 14.1593 9.48787 14.329 9.48975 14.5C9.48795 14.6695 9.52073 14.8377 9.58606 14.9941C9.65139 15.1506 9.74792 15.292 9.86975 15.4099C9.98937 15.531 10.1319 15.6272 10.2889 15.6929C10.446 15.7585 10.6146 15.7922 10.7848 15.7922C10.955 15.7922 11.1236 15.7585 11.2806 15.6929C11.4377 15.6272 11.5801 15.531 11.6997 15.4099Z"
                                      fill="#36BEF0"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="two">
                          <div class="home_button2">
                            <svg
                              width="19"
                              height="16"
                              viewBox="0 0 19 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.6997 15.4099L18.1798 8.92993C18.3009 8.81031 18.397 8.66781 18.4626 8.51074C18.5283 8.35367 18.5621 8.18512 18.5621 8.01489C18.5621 7.84466 18.5283 7.67611 18.4626 7.51904C18.397 7.36197 18.3009 7.21947 18.1798 7.09985L11.6997 0.619873C11.5795 0.499714 11.4369 0.404385 11.2799 0.339355C11.1229 0.274326 10.9547 0.240967 10.7848 0.240967C10.6149 0.240967 10.4465 0.274326 10.2896 0.339355C10.1326 0.404385 9.98991 0.499714 9.86975 0.619873C9.74959 0.740033 9.65426 0.882799 9.58923 1.03979C9.5242 1.19679 9.49072 1.36498 9.49072 1.53491C9.49072 1.70484 9.5242 1.87303 9.58923 2.03003C9.65426 2.18703 9.74959 2.32979 9.86975 2.44995L14.1298 6.71997H1.70972C1.53009 6.70417 1.34924 6.72579 1.17847 6.78369C1.0077 6.84159 0.850748 6.93436 0.717773 7.05615C0.584799 7.17794 0.478649 7.32617 0.406006 7.49121C0.333363 7.65625 0.295898 7.83457 0.295898 8.01489C0.295898 8.19521 0.333363 8.37353 0.406006 8.53857C0.478649 8.70362 0.584799 8.85184 0.717773 8.97363C0.850748 9.09542 1.0077 9.18819 1.17847 9.24609C1.34924 9.304 1.53009 9.32561 1.70972 9.30981H14.1298L9.86975 13.5798C9.74772 13.6997 9.65111 13.8431 9.58582 14.0012C9.52052 14.1593 9.48787 14.329 9.48975 14.5C9.48795 14.6695 9.52073 14.8377 9.58606 14.9941C9.65139 15.1506 9.74792 15.292 9.86975 15.4099C9.98937 15.531 10.1319 15.6272 10.2889 15.6929C10.446 15.7585 10.6146 15.7922 10.7848 15.7922C10.955 15.7922 11.1236 15.7585 11.2806 15.6929C11.4377 15.6272 11.5801 15.531 11.6997 15.4099Z"
                                fill="#36BEF0"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </figcaption>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="page m54" ref="pageHide"><div class="div"></div></div>
        </div>
      </div>
    </section>

    <section class="Home_about">
      <div class="w1520 p95 p95_">
        <div class="box flexBetween">
          <div class="boxLeft">
            <div class="homeTitle wow animate__animated animate__fadeInUp">
              <div class="f60" v-html="about_title.typename"></div>
            </div>
            <div
              class="content1 wow animate__animated animate__fadeInUp"
              v-html="about_data.title"
            ></div>
            <div
              class="content2 wow animate__animated animate__fadeInUp"
              v-html="about_data.desc"
            ></div>
            <div class="content3 wow animate__animated animate__fadeInUp">
              <div class="home_button3">
                <router-link to="/about" class="a flexCenter">
                  <div class="l">了解丰格</div>
                  <div class="r">
                    <div class="home_button2">
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.6997 15.4099L18.1798 8.92993C18.3009 8.81031 18.397 8.66781 18.4626 8.51074C18.5283 8.35367 18.5621 8.18512 18.5621 8.01489C18.5621 7.84466 18.5283 7.67611 18.4626 7.51904C18.397 7.36197 18.3009 7.21947 18.1798 7.09985L11.6997 0.619873C11.5795 0.499714 11.4369 0.404385 11.2799 0.339355C11.1229 0.274326 10.9547 0.240967 10.7848 0.240967C10.6149 0.240967 10.4465 0.274326 10.2896 0.339355C10.1326 0.404385 9.98991 0.499714 9.86975 0.619873C9.74959 0.740033 9.65426 0.882799 9.58923 1.03979C9.5242 1.19679 9.49072 1.36498 9.49072 1.53491C9.49072 1.70484 9.5242 1.87303 9.58923 2.03003C9.65426 2.18703 9.74959 2.32979 9.86975 2.44995L14.1298 6.71997H1.70972C1.53009 6.70417 1.34924 6.72579 1.17847 6.78369C1.0077 6.84159 0.850748 6.93436 0.717773 7.05615C0.584799 7.17794 0.478649 7.32617 0.406006 7.49121C0.333363 7.65625 0.295898 7.83457 0.295898 8.01489C0.295898 8.19521 0.333363 8.37353 0.406006 8.53857C0.478649 8.70362 0.584799 8.85184 0.717773 8.97363C0.850748 9.09542 1.0077 9.18819 1.17847 9.24609C1.34924 9.304 1.53009 9.32561 1.70972 9.30981H14.1298L9.86975 13.5798C9.74772 13.6997 9.65111 13.8431 9.58582 14.0012C9.52052 14.1593 9.48787 14.329 9.48975 14.5C9.48795 14.6695 9.52073 14.8377 9.58606 14.9941C9.65139 15.1506 9.74792 15.292 9.86975 15.4099C9.98937 15.531 10.1319 15.6272 10.2889 15.6929C10.446 15.7585 10.6146 15.7922 10.7848 15.7922C10.955 15.7922 11.1236 15.7585 11.2806 15.6929C11.4377 15.6272 11.5801 15.531 11.6997 15.4099Z"
                          fill="#36BEF0"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="boxRight">
            <div class="item item1 wow animate__animated animate__fadeInUp">
              <div class="ite">
                <div class="top">
                  <span id="target1">{{ about_data.xxzl }} </span>项
                </div>
                <div class="bot">发明及实用新型专利</div>
              </div>
            </div>
            <div class="item item2 wow animate__animated animate__fadeInUp">
              <div class="ite">
                <div class="top">
                  <span id="target2">{{ about_data.scjy }}</span
                  >年
                </div>
                <div class="bot">热风生产经验</div>
              </div>
            </div>
            <div class="item item3 wow animate__animated animate__fadeInUp">
              <div class="ite">
                <div class="top">
                  <span id="target3">{{ about_data.scnl }}</span
                  >吨
                </div>
                <div class="bot">年生产能力</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="Home_News">
      <div class="w1520 p95">
        <div class="flexBetween wow animate__animated animate__fadeInUp">
          <div class="left">
            <div class="homeTitle">
              <div class="f60">
                <span>NEWS</span> <em class="f48">新闻资讯</em>
              </div>
            </div>
          </div>
          <div class="right pc">
            <div class="home_button1">
              <router-link to="/news" class="a flexCenter">
                <div class="l">更多资讯</div>
                <div class="r">
                  <div class="home_button2">
                    <svg
                      width="19"
                      height="16"
                      viewBox="0 0 19 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.6997 15.4099L18.1798 8.92993C18.3009 8.81031 18.397 8.66781 18.4626 8.51074C18.5283 8.35367 18.5621 8.18512 18.5621 8.01489C18.5621 7.84466 18.5283 7.67611 18.4626 7.51904C18.397 7.36197 18.3009 7.21947 18.1798 7.09985L11.6997 0.619873C11.5795 0.499714 11.4369 0.404385 11.2799 0.339355C11.1229 0.274326 10.9547 0.240967 10.7848 0.240967C10.6149 0.240967 10.4465 0.274326 10.2896 0.339355C10.1326 0.404385 9.98991 0.499714 9.86975 0.619873C9.74959 0.740033 9.65426 0.882799 9.58923 1.03979C9.5242 1.19679 9.49072 1.36498 9.49072 1.53491C9.49072 1.70484 9.5242 1.87303 9.58923 2.03003C9.65426 2.18703 9.74959 2.32979 9.86975 2.44995L14.1298 6.71997H1.70972C1.53009 6.70417 1.34924 6.72579 1.17847 6.78369C1.0077 6.84159 0.850748 6.93436 0.717773 7.05615C0.584799 7.17794 0.478649 7.32617 0.406006 7.49121C0.333363 7.65625 0.295898 7.83457 0.295898 8.01489C0.295898 8.19521 0.333363 8.37353 0.406006 8.53857C0.478649 8.70362 0.584799 8.85184 0.717773 8.97363C0.850748 9.09542 1.0077 9.18819 1.17847 9.24609C1.34924 9.304 1.53009 9.32561 1.70972 9.30981H14.1298L9.86975 13.5798C9.74772 13.6997 9.65111 13.8431 9.58582 14.0012C9.52052 14.1593 9.48787 14.329 9.48975 14.5C9.48795 14.6695 9.52073 14.8377 9.58606 14.9941C9.65139 15.1506 9.74792 15.292 9.86975 15.4099C9.98937 15.531 10.1319 15.6272 10.2889 15.6929C10.446 15.7585 10.6146 15.7922 10.7848 15.7922C10.955 15.7922 11.1236 15.7585 11.2806 15.6929C11.4377 15.6272 11.5801 15.531 11.6997 15.4099Z"
                        fill="#36BEF0"
                      />
                    </svg>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="box m54 wow animate__animated animate__fadeInUp">
        <div class="banner">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in new_data"
                :key="index"
              >
                <router-link :to="{ path: '/newsInfo?id=' + item.aid }">
                  <div class="top">
                    <div class="tit ellipsis2">
                      {{ item.title }}
                    </div>
                    <div class="time">
                      {{ (item.add_times * 1000) | conversion("yyyy.MM.dd") }}
                    </div>
                  </div>
                  <div class="bot ellipsis2">
                    {{ item.desc }}
                  </div>
                  <div class="orientation"></div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box1 m54 p95_">
        <div class="w1520 flexBetween">
          <div class="l">
            <div class="page"></div>
          </div>
          <div class="r">
            <div class="prev btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="19px"
                height="17px"
              >
                <path
                  fill-rule="evenodd"
                  fill="rgb(54, 190, 240)"
                  d="M7.285,0.956 L0.804,7.438 C0.298,7.944 0.298,8.764 0.804,9.270 L7.285,15.752 C7.791,16.259 8.612,16.259 9.118,15.752 C9.624,15.246 9.624,14.425 9.118,13.919 L4.850,9.650 L17.275,9.650 C17.992,9.650 18.572,9.070 18.572,8.354 C18.572,7.638 17.992,7.058 17.275,7.058 L4.850,7.058 L9.118,2.789 C9.371,2.535 9.498,2.204 9.498,1.872 C9.498,1.541 9.372,1.209 9.118,0.956 C8.612,0.450 7.791,0.450 7.285,0.956 L7.285,0.956 Z"
                />
              </svg>
            </div>
            <div class="next btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="19px"
                height="17px"
              >
                <path
                  fill-rule="evenodd"
                  fill="rgb(54, 190, 240)"
                  d="M11.699,15.754 L18.181,9.273 C18.687,8.767 18.687,7.946 18.181,7.440 L11.699,0.958 C11.193,0.452 10.373,0.452 9.866,0.958 C9.360,1.464 9.360,2.285 9.866,2.791 L14.135,7.060 L1.709,7.060 C0.993,7.060 0.413,7.640 0.413,8.356 C0.413,9.072 0.993,9.652 1.709,9.652 L14.135,9.652 L9.866,13.921 C9.614,14.175 9.487,14.506 9.487,14.838 C9.487,15.170 9.613,15.502 9.866,15.754 C10.373,16.261 11.193,16.261 11.699,15.754 L11.699,15.754 Z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="box2 phone flexCenter m54">
          <div class="home_button1">
            <a class="a flexCenter" href="">
              <div class="l">更多资讯</div>
              <div class="r">
                <div class="home_button2">
                  <svg
                    width="19"
                    height="16"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.6997 15.4099L18.1798 8.92993C18.3009 8.81031 18.397 8.66781 18.4626 8.51074C18.5283 8.35367 18.5621 8.18512 18.5621 8.01489C18.5621 7.84466 18.5283 7.67611 18.4626 7.51904C18.397 7.36197 18.3009 7.21947 18.1798 7.09985L11.6997 0.619873C11.5795 0.499714 11.4369 0.404385 11.2799 0.339355C11.1229 0.274326 10.9547 0.240967 10.7848 0.240967C10.6149 0.240967 10.4465 0.274326 10.2896 0.339355C10.1326 0.404385 9.98991 0.499714 9.86975 0.619873C9.74959 0.740033 9.65426 0.882799 9.58923 1.03979C9.5242 1.19679 9.49072 1.36498 9.49072 1.53491C9.49072 1.70484 9.5242 1.87303 9.58923 2.03003C9.65426 2.18703 9.74959 2.32979 9.86975 2.44995L14.1298 6.71997H1.70972C1.53009 6.70417 1.34924 6.72579 1.17847 6.78369C1.0077 6.84159 0.850748 6.93436 0.717773 7.05615C0.584799 7.17794 0.478649 7.32617 0.406006 7.49121C0.333363 7.65625 0.295898 7.83457 0.295898 8.01489C0.295898 8.19521 0.333363 8.37353 0.406006 8.53857C0.478649 8.70362 0.584799 8.85184 0.717773 8.97363C0.850748 9.09542 1.0077 9.18819 1.17847 9.24609C1.34924 9.304 1.53009 9.32561 1.70972 9.30981H14.1298L9.86975 13.5798C9.74772 13.6997 9.65111 13.8431 9.58582 14.0012C9.52052 14.1593 9.48787 14.329 9.48975 14.5C9.48795 14.6695 9.52073 14.8377 9.58606 14.9941C9.65139 15.1506 9.74792 15.292 9.86975 15.4099C9.98937 15.531 10.1319 15.6272 10.2889 15.6929C10.446 15.7585 10.6146 15.7922 10.7848 15.7922C10.955 15.7922 11.1236 15.7585 11.2806 15.6929C11.4377 15.6272 11.5801 15.531 11.6997 15.4099Z"
                      fill="#36BEF0"
                    />
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </main>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

import { CountUp } from "countup.js";

export default {
  name: "Home",
  data() {
    return {
      banner_data: [],
      product_title: {},
      product_data: [],
      about_title: {},
      about_data: {},
      new_data: [],
      total: 100,
      options: {
        duration: 2,
        useEasing: false,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: "",
      },
    };
  },
  beforeMount() {
    this.index_res();
  },
  mounted() {
    // 创建实例  循环调用 所有 dom
    const io = new IntersectionObserver((entries) => {
      this.dg_()
    });
    // 获取所有 countToWrapper 标签 开始观察
    const countToWrapper = document.querySelector(
      "#target1"
    );
    io.observe(countToWrapper);

  },
  methods: {
    banner_swiper() {
      new Swiper(".Home_Banner .swiper-container", {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 800,
        pagination: {
          el: ".Home_Banner .page div",
          clickable: true,
        },
      });



     this.$refs.swiperitem.children.length<=3?this.$refs.pageHide.remove():''


      new Swiper(".Home_Product .swiper-container", {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 50,
        pagination: {
          el: ".Home_Product .page div",
          clickable: true,
        },

        breakpoints: {
          1200: { slidesPerView: 3, spaceBetween: 50 },
          500: { slidesPerView: 2, spaceBetween: 20 },
          320: { slidesPerView: 1, spaceBetween: 50 },
        },
      });

      new Swiper(".Home_News .swiper-container", {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 800,
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: {
          el: ".Home_News .page",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".Home_News .next",
          prevEl: ".Home_News .prev",
        },
      });
    },
    async index_res() {
      let that = this;
      await this.$httpPost("/index", {})
        .then((res) => {
          that.banner_data = res.channelList[0].list;
          that.product_title = res.channelList[1];
          that.product_data = res.channelList[1].list;
          that.about_title = res.channelList[2];
          that.about_data = res.channelList[2].list[0];
          that.new_data = res.newList;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$nextTick(() => {
        this.banner_swiper();
      });
    },

    dg_() {
      let demo1 = new CountUp("target1", this.about_data.xxzl);
      demo1.start();
      let demo2 = new CountUp("target2", this.about_data.scjy);
      demo2.start();
      let demo3 = new CountUp("target3", Number(this.about_data.scnl));
      demo3.start();
    },
  },
};
</script>
